/**
 * Format a number with comma separators.
 */
export function formatNumber(n) {
  if (n === null || n === undefined) return '0';
  return n.toLocaleString();
}

/**
 * Format an ISO date string to a human-readable relative or absolute format.
 */
export function formatDate(isoString) {
  if (!isoString) return '';

  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/**
 * Format a sequence ID into a human-readable name.
 * e.g., "loop1_onboarding" -> "Loop 1 -- Onboarding"
 */
/**
 * Slugify a string for URL-safe slugs.
 */
export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}

/**
 * Format a date as relative time ago string.
 */
export function timeAgo(date) {
  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'week', seconds: 604800 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
  ];

  for (const interval of intervals) {
    const count = Math.floor(seconds / interval.seconds);
    if (count >= 1) return `${count} ${interval.label}${count > 1 ? 's' : ''} ago`;
  }
  return 'just now';
}

/**
 * Format bytes to human-readable size.
 */
export function formatBytes(bytes) {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

/**
 * Format a sequence ID into a human-readable name.
 * e.g., "loop1_onboarding" -> "Loop 1 -- Onboarding"
 */
export function formatSequenceName(sequenceId) {
  if (!sequenceId) return '';

  const match = sequenceId.match(/^loop(\d+)_(.+)$/);
  if (!match) return sequenceId;

  const loopNum = match[1];
  const name = match[2]
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

  return `Collection ${loopNum} — ${name}`;
}
